<!-- Sign in to Firebase First -------------------------------------------------------------------------->
<div class="cpcontent googlesignin" [hidden]="isAuthenticatedWithFirebase">
    <h5>Signin with Google to access the Firebase database</h5>
    <br>
    <div class="row">
        <div class="col-md-6">
            <button class="btn btn-primary" (click)="signInWithGoogle()">Sign in with Google</button>
        </div>
    </div>
</div>
<div class="cpcontent" [hidden]="!isAuthenticatedWithFirebase">
    <h1>Measurements in Firebase Database</h1>
    <div class="row">
        <div class="col-md-4">
            <button class="btn btn-primary" (click)="addScenarioModal()" style="margin-left:20px">Add Scenario</button>
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th>name</th>
                        <th>Start Date</th>
                        <th>Last Date</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>

                    <tr *ngFor="let c of measurementsArray;let i = index">
                        <td class="link" (click)="selectScenario(c.name)">{{c.name}}</td>
                        <td>{{c.startDate | date: 'short'}}</td>
                        <td>{{c.lastDate | date: 'short'}}</td>
                        <td><button class="btn btn-warning" (click)="deleteScenario(c.name)">delete</button></td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-md-4">
            <b>{{scenarioName}}</b>
            <input type="text" [(ngModel)]="newPlayerName" style="display:inline-block;margin-left:10px;margin-right:10px"/>
            <button class="btn btn-primary" (click)="addPlayer()">Add Player</button>
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th>name</th>
                        <th>delete</th>
                    </tr>
                </thead>
                <tbody>

                    <tr *ngFor="let c of players;let i = index">
                        <td class="link" (click)="selectPlayer(c)">{{c.name}}</td>
                        <td><button class="btn btn-warning" (click)="deletePlayer(c.name)">delete</button></td>
                    </tr>
                </tbody>
            </table>
            <br>
            {{scenario | json}}
        </div>
        <div class="col-md-4">
            <h5>Example of records in Forebase Database</h5>
            <img src="assets/FB_Measurements.png" style="width:100%"/>
        </div>
    </div>
    Recordings of player {{player.name}}
    <button class="btn btn-primary" (click)="addRecordModal()" style="margin-left:20px">Add Record</button>
    <table class="table table-bordered">
        <thead>
            <tr>
                <th>Id</th>
                <th>Room</th>
                <th>Component</th>
                <th>Substrate</th>
                <th>Reading [mg/cm2]</th>
                <th>Notes</th>
                <th>delete</th>
            </tr>
        </thead>
        <tbody>

            <tr *ngFor="let c of recordings;let i = index">
                <td>{{i}}</td>
                <td>{{c.room}}</td>
                <td>{{c.component}}</td>
                <td>{{c.substrate}}</td>
                <td>{{c.reading}}</td>
                <td>{{c.notes}}</td>
                <td><button class="btn btn-warning" (click)="deleteRecord(i)">delete</button></td>
            </tr>
        </tbody>
    </table>
    <br>
    <button class="btn btn-primary" (click)="updateRecordings()">Update</button>
    <br>
    Player: 
    {{player | json }}

</div>

<!-- Modal Add Scenario---------------------------------------------------------------------------->
<div *ngIf="showAddScenario" #testmodal class="cpmodal">
    <div class="cpmodal-content" style="max-width:1400px;margin-top:5%">
        <h5 style="display:inline-block;margin-right:20px">Add Scenario Name</h5>
        <sa-input-text [(text)]="newScenarioaname" [title]="'Scneario Name'"></sa-input-text>
        <button class="btn btn-primary" (click)="addScenario()">Add Scenario</button>

        <button class="btn btn-primary" style="float:right" (click)="showAddScenario = false">Close Modal</button>
    </div>
</div>
<!-- Modal Add Scenario---------------------------------------------------------------------------->
<div *ngIf="showAddRecord" #testmodal class="cpmodal">
    <div class="cpmodal-content" style="max-width:1400px;margin-top:5%">
        <h5 style="display:inline-block;margin-right:20px">Add Record</h5>
        <sa-input-text [(text)]="record.room" [title]="'Room'"></sa-input-text>
        <sa-input-text [(text)]="record.component" [title]="'Component'"></sa-input-text>
        <sa-input-text [(text)]="record.substrate" [title]="'Substrate'"></sa-input-text>
        <sa-input-text [(text)]="record.reading" [title]="'Lead Content [mg/cm2]'"></sa-input-text>
        <sa-input-text [(text)]="record.notes" [title]="'Additional Notes'"></sa-input-text>
        <button class="btn btn-primary" (click)="addRecord()">Add Scenario</button>

        <button class="btn btn-primary" style="float:right" (click)="showAddRecord = false">Close Modal</button>
    </div>
</div>